import type { ChangeFavoritePayload as Request } from '../model/types.tsx';
import { updateFavorite } from '../rest/update-favorite.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default async (request: Request): Promise<void> => updateFavorite(request);
